import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const _getters = {
    getSections: state => state.sections,
    getAllSections: state => state.getAllSections,
    getPages: state => state.pages ,
    getTeams: state => state.teams,
    getSocials: state => state.socials,
    getNewsYears: state => state.newsYears,
    getTeamsWithCategories: state => state.teamsWithCategories
}

const store = new Vuex.Store({
    state: {
        sections: [],
        allSections: [],
        pages: [],
        teams: [],
        socials: [],
        newsYears: [],
        teamsWithCategories: []
    },
    mutations: {
        sections (state, sections) {
            state.sections = sections
        },
        allSections (state, sections) {
            state.allSections = sections
        },
        pages (state, pages) {
            state.pages = pages
        },
        teams (state, teams) {
            state.teams = teams
        },
        socials (state, socials) {
            state.socials = socials
        },
        newsYears (state, newsYears) {
            state.newsYears = newsYears
        },
        teamsWithCategories (state, teamsWithCategories) {
            state.teamsWithCategories = teamsWithCategories
        }
    },
    getters: _getters
})

export default store
